import { Component, Input } from '@angular/core';
import { FormBuilder, NgForm } from '@angular/forms';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AlertesService } from '../../services/public/alertes.service';
import {EnrollementService} from "../../services/frapper/enrollement.service";
import { JugementsService } from '../../services/frapper/jugements.service';
import * as $ from 'jquery';
import { CustomService } from '../../services/frapper/custom.service';

@Component({
  selector: 'app-add-infractions',
  templateUrl: './add-infractions.component.html',
  styleUrls: ['./add-infractions.component.scss']
})
export class AddInfractionsComponent {
  @Input() parentModal: BsModalRef;


  data: any;
  type:any;
  label_default: any;
  modalRef!: BsModalRef;
  tableData: any[] = [];
  list_profil:  any[] = [
    {
      "name": "AGENT DU COURRIER"

    },
    {
      "name": "ADMIN TRIBUNAL"

    },
    {
      "name": "AGENT DU COURRIER CIVIL"

    },
    {
      "name": "AGENT DU COURRIER FAMILIAL"

    },
    {
      "name": "AGENT DU COURRIER SOCIAL"

    },
    {
      "name": "AGENT DU COURRIER PRESIDENT"

    },
    {
      "name": "AGENT DU COURRIER GREF"
    },
    {
      "name": "PROCUREUR"
    },
    {
      "name": "SUB PROCUREUR"
    },
    {
      "name": "GREFFIER"
    },
    {
      "name": "GREFFIER EN CHEF"
    },
    {
      "name": "JUGE D'INSTRUCTION"
    },
    {
      "name": "GREFFIER D'INSTRUCTION"
    },
    {
      "name": "JUGE"
    },
    {
      "name": "PRESIDENT DU TRIBUNAL"
    },
    {
      "name": "AGENT EXECUTION PEINES"
    },
    {
      "name": "AGENT NATURALISATION"
    },
    {
      "name": "AGENT ENROLEMENT"
    },
    {
      "name": "AGENT ENROLEMENT PENAL"
    },
    {
      "name": "AGENT RDV"
    },
    {
      "name": "AGENT DU CASIER"
    },

  ]

  constructor(private modalService: BsModalService,
              public options: ModalOptions,
              private formBuilder: FormBuilder,
              private enrolementService:EnrollementService,
              private jugementService:JugementsService,
              private customService:CustomService,
              private ngxService: NgxUiLoaderService,
              private alerte:AlertesService,

              public bsModalRef: BsModalRef,

             ) {

    this.data = options.initialState.data
    this.type = options.initialState.type
    console.log('the type:', this.type);

    this.label_default = options.initialState.label

  }

  closeWithMessage(message: string) {
    this.bsModalRef.hide();
    this.bsModalRef.onHidden.emit(message);
  }
  closeModal(){
    this.bsModalRef.hide()
  }

  getDataTable(){
    const table = document.getElementById('myTable') as HTMLTableElement;
    if (!table) return;

    const rows = table.querySelectorAll('tbody tr');

    rows.forEach(row => {
      const select = row.querySelector('select[name="doctype_assigned"]') as HTMLSelectElement;

     
        this.tableData.push({role:select.value});
      
    });

    console.log('Contenu du tableau récupéré :', this.tableData);

    // Si besoin, stocker dans une variable Angular
    // this.data.profil_allowed = tableData;
  }
  AddNewItem(infraction: NgForm){
    this.ngxService.start();
    let body_content = infraction.value
    switch (this.type) {
      case "infraction":
        try {
          this.enrolementService.nouvelleInfraction(body_content).then(res =>{
            this.ngxService.stop();
            this.closeWithMessage('success')
          },err=>{
            this.ngxService.stop();
          })
        } catch (error) {
          this.closeWithMessage('error')
        }
       
        break;

      case "decision":
        try {
          this.jugementService.nouveauDecision(body_content).then(res =>{
            this.ngxService.stop();
            this.closeWithMessage('success')
          },err=>{
            this.ngxService.stop();
          })
        } catch (error) {
          this.closeWithMessage('error')
        }
       
        break;

      case "categorie":
        try {
          this.jugementService.nouvelleCategorie(body_content).then(res =>{
            this.ngxService.stop();
            this.closeWithMessage('success')
          },err=>{
            this.ngxService.stop();
          })
        } catch (error) {
          this.closeWithMessage('error')
        }
        
        break;

      case "action_st":
        try {
          this.getDataTable()
          body_content['profil_allowed'] = this.tableData
          console.log('body_content', body_content);
          
          this.customService.newActions(body_content).then(res =>{
            this.ngxService.stop();
            this.closeWithMessage('success')
          },err=>{
            this.ngxService.stop();
          })
        } catch (error) {
          this.closeWithMessage('error')
        }
        
        break;
    
      default:
        break;
    }
    
    //console.log('body=>', body_content)



  }
  ngAfterViewInit(): void {

    setTimeout(() => {
      let rowCount = 0;
  
    var self = this;
    $('#addRowBtn').click(function () {
      rowCount++;
  
      const options = self.list_profil.map(item => `<option value="${item.name}">${item.name}</option>`).join('');
  
      const newRow = `
        <tr>
          <td>
            <select class="custom-select" name="doctype_assigned">
              ${options}
            </select>
          </td>
          <td class="col-md-2 col-sm-2">
            <i class="fas fa-trash text-danger delete" style="font-size: 20px; cursor:pointer;"></i>
          </td>
        </tr>
      `;
  
      $('#myTable tbody').append(newRow);
    });
  
    // Délégation d'événement pour les suppressions
    $('#myTable').on('click', '.delete', function () {
      $(this).closest('tr').remove();
    });
    }, 200);
    
  }
  ngOnInit() {



    // let rowCount = 0;
    // var self = this;
    // $("#addRowBtn").click(function() {
    //   rowCount++;
    //   const options = self.list_profil.map(item => `<option value="${item.name}">${item.name}</option>`).join('');

    //   const newRow = `
    //       <tr>            
    //         <td>
    //           <select class="custom-select" name="doctype_assigned">
    //             ${options}
    //           </select>
    //         </td>
    //         <td class="col-md-2 col-sm-2">
    //           <i class="fas fa-trash text-danger delete" style="font-size: 20px; cursor:pointer;"></i>
    //         </td>
    //       </tr>
    //     `;
    //   $("#myTable tbody").append(newRow);
    //   $(document).on("click", ".delete", function() {
    //     $(this).closest("tr").remove();
    //     // Mise à jour des numéros de ligne
    //     // $("#myTable tbody tr").each(function(index) {
    //     //   $(this).find("td:first").text(index + 1);
    //     // });
    //   });
    // });
    //   // Gérer la suppression d'une ligne
    //   $('#myTable').on('click', '.delete-row', function() {
    //       $(this).closest('tr').remove(); // Supprimer la ligne parente (tr) du clic sur l'icône poubelle (delete-row)
    //   });


  }
}
